<template lang="pug">

    .ui.input
        input(v-bind:value="value" disabled)

</template>

<script>
    export default {
        name: "ProductFormsVariantFormsFormFieldUnknownField",

        computed: {
            value() {
                return `UNBEKANNTER FELDTYP: ${this.field.type}`
            }
        },

        props: {
            field: {
                type: Object,
                required: true
            }
        }

    }
</script>
